import { memo } from 'react'
import { Stack } from '@mui/material'
import { useResizeDetector } from 'react-resize-detector'
import { ViewType } from '../../../assets/constants'
import LtpView from '../ltpView/ltpView'
import MarketStatus from '../marketStatus'
import { useStyles } from './styles'

type Props = {
    viewType: ViewType
}

/** Isolates resize + LTP updates so the stock bar shell does not re-render on each tick. */
const StockBarLtpSection = ({ viewType }: Props) => {
    const { classes } = useStyles()
    const { width } = useResizeDetector({
        handleHeight: false,
        refreshMode: 'debounce',
        refreshRate: 300
    })

    // Do not key by viewType — CHART→TECHNICALS/SEASONALS/FINANCIAL remounts blanked LTP
    // until LiveMarketText's effect reapplied. Those views all show the same primary LTP;
    // LtpView already adapts via the `view` prop.
    return (
        <Stack gap={2} className={classes.ltpStack}>
            <LtpView view={viewType} width={width} />
            <MarketStatus />
        </Stack>
    )
}

export default memo(StockBarLtpSection)
